import type { Technician } from '@/api/orders'
import { fetchActiveTechnicianList, type TechnicianListItem } from '@/api/technicianslist'
import {
  buildTechnicianNoLookup,
  type TechnicianNoLookup,
} from '@/utils/technicianNoFromList'

/** 与技术员页 Role=Inspector 一致 */
export function isInspectorWorkRole(role: string | undefined | null): boolean {
  return String(role ?? '').trim().toLowerCase() === 'inspector'
}

export type ScheduleInspectorLoadResult = {
  lookup: TechnicianNoLookup | null
  rows: (Technician & { staffNo?: string })[]
  inspectorIds: Set<string>
}

let inflight: Promise<ScheduleInspectorLoadResult> | null = null

function rowsFromTechnicianListItems(list: TechnicianListItem[]): ScheduleInspectorLoadResult {
  const inspectorIds = new Set(
    list.filter((item) => isInspectorWorkRole(item.work_role)).map((item) => String(item.id)),
  )
  const rows: (Technician & { staffNo?: string })[] = []
  for (const item of list) {
    const name = (item.name ?? '').trim()
    if (!name) continue
    const licenseNo = (item.license_no ?? '').trim()
    const row: Technician & { staffNo?: string } = { id: String(item.id), name }
    if (licenseNo) row.staffNo = licenseNo
    rows.push(row)
  }
  return {
    lookup: buildTechnicianNoLookup(list),
    rows,
    inspectorIds,
  }
}

async function fetchScheduleInspectorData(): Promise<ScheduleInspectorLoadResult> {
  try {
    const list = await fetchActiveTechnicianList()
    return rowsFromTechnicianListItems(list)
  } catch {
    return { lookup: null, rows: [], inspectorIds: new Set() }
  }
}

/** 已废弃：不再预热技术员缓存。保留空实现，避免旧 bundle / 热更新残留引用报错 */
export function primeScheduleInspectorCache(_list?: TechnicianListItem[]): void {}

/** 每次直接 POST technician/list，仅同参 in-flight 去重，不做 TTL 缓存 */
export function getScheduleInspectorData(): Promise<ScheduleInspectorLoadResult> {
  if (inflight) return inflight
  inflight = fetchScheduleInspectorData().finally(() => {
    inflight = null
  })
  return inflight
}
